module.exports = __webpack_public_path__ + "img/banner.bbe8022c.png";